import { useEffect, useState, useRef } from 'react'
import classes from './SpecialInstructionsBuilder.module.css'
import { useSelector } from 'react-redux';
import CustomMessage from './CustomMessage';
import CustomDesign from './CustomDesign';
import SpecialInstructions from '../products_details_v3/SpecialInstructions';

const SpecialInstructionsBuilder = ({specialinstructionsText}) => {
    // const options = useSelector(state => state.product.product)
    const productDetails = useSelector(state => state.productDetails.data)


    const [activeFields, setActiveFields] = useState({
        message: false,
        design: false
    })

    const [showNormalSpecialInstructions, setShowNormalSpecialInstructions] = useState(false)

    useEffect(() => {
        productDetails.forEach(mod => {
            if (mod.description.toLowerCase().includes("custom")) {
                setShowNormalSpecialInstructions(false)
                if (mod.itemSelected) {
                    if (mod.options.length > 0) {
                        if (mod.options[0].itemSelected && mod.options[0].itemSelected === true) {
                            setActiveFields({
                                message: true,
                                design: false
                            })
                        } else if (mod.options[1].itemSelected && mod.options[1].itemSelected === true) {
                            setActiveFields({
                                message: true,
                                design: true
                            })
                        } else {
                            setActiveFields({
                                message: false,
                                design: false
                            })
                        }
                    }
                } else {
                    setActiveFields({
                        message: false,
                        design: false
                    })
                }
            } else {
                // we are on create product but no custom field is ProgressEvent, so show the normal special instruction field 

                setShowNormalSpecialInstructions(true)
            }
        });
    }, [productDetails])


    return <>
        {(activeFields.message || activeFields.design) && <div className={`${classes.options_item} ${classes.options_item_customize}`} >
            <div className={classes.options_item_header}>
                <h3>Cake Customization:</h3>
            </div>
            {(activeFields.message || activeFields.design) && <CustomMessage text={specialinstructionsText.message}/>}
            {activeFields.design && <CustomDesign text={specialinstructionsText.design}/>}
            
        </div>}

        {showNormalSpecialInstructions && <SpecialInstructions />}
    </>
}

export default SpecialInstructionsBuilder